import { LANGUAGE_DEFAULT } from '@src/configs/const.config'
import { TCreateManyQuiz, TCreateQuiz, TPatchQuiz, TQueryQuiz } from '@src/modules'

import { request } from './config'

export const createQuiz = (data: TCreateQuiz) => request({ url: 'contest-quiz', method: 'POST', data })
export const createManyQuiz = (data: TCreateManyQuiz) =>
  request({ url: 'contest-quiz/create-many', method: 'POST', data })
export const getListQuiz = (params: TQueryQuiz, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: 'contest-quiz', method: 'GET', params }, { token, lang })
export const getQuizById = (id: string, token?: string, lang = LANGUAGE_DEFAULT) =>
  request({ url: `contest-quiz/${id}`, method: 'GET' }, { token, lang })
export const patchQuizById = (id: string, data: TPatchQuiz) =>
  request({ url: `contest-quiz/${id}`, method: 'PATCH', data })
export const removeQuizById = (id: string) => request({ url: `contest-quiz/${id}`, method: 'DELETE' })
